export const categories = [
  {
    slug: 'zixun',
    name: '最新资讯',
    description: '获取地址发布页最新动态与公告',
    icon: 'ri-newspaper-line',
    color: 'primary',
  },
  {
    slug: 'jiaocheng',
    name: '使用教程',
    description: '详细的使用指南与操作教程',
    icon: 'ri-book-open-line',
    color: 'accent',
  },
  {
    slug: 'wenti',
    name: '常见问题',
    description: '访问与使用中的常见问题解答',
    icon: 'ri-question-answer-line',
    color: 'secondary',
  },
  {
    slug: 'gonggao',
    name: '官方公告',
    description: '官方发布的正式公告与通知',
    icon: 'ri-megaphone-line',
    color: 'primary',
  },
  {
    slug: 'anquan',
    name: '安全指南',
    description: '保障账号与访问安全的实用建议',
    icon: 'ri-shield-check-line',
    color: 'accent',
  },
  {
    slug: 'gengxin',
    name: '版本更新',
    description: '平台版本更新日志与功能说明',
    icon: 'ri-refresh-line',
    color: 'secondary',
  },
];

export const articleSlugs = [
  'zixun-zhaohui-2026',
  'zixun-yunwei-2026',
  'zixun-beiyong-2026',
  'jiaocheng-ruhe-shoucang',
  'jiaocheng-ruhe-gengxin',
  'jiaocheng-xinshou-zhinan',
  'wenti-wufa-fangwen',
  'wenti-jiaman-jiejue',
  'wenti-zhanghao-anquan',
  'gonggao-zhengshi-shangxian',
  'gonggao-weihu-tongzhi',
  'gonggao-xinbanben-fabu',
  'anquan-fang-diaoyu',
  'anquan-mima-baohu',
  'anquan-erci-yanzheng',
  'gengxin-v2-1-0',
  'gengxin-v2-0-0',
  'gengxin-v1-5-0',
];